import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import App from './AppSelector';
import ErrorBoundary from './ErrorBoundary';
import ThemedComponent from './ThemedComponent';
import ConfirmOptions from './ConfirmOptions';

const Entrypoint = () => (
  <ThemedComponent>
    <ErrorBoundary>
      <ConfirmOptions>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <App />
        </LocalizationProvider>
      </ConfirmOptions>
    </ErrorBoundary>
  </ThemedComponent>
);

export default Entrypoint;
